import NiceModal from '@ebay/nice-modal-react';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { initI18n } from './config/i18n';
import { init as initAnalytics } from './lib/analytics/functions/init';
import { init as initFeatureFlags } from './lib/feature-flags/functions/init';
import { init as initObservability } from './lib/observability/functions/init';
import './styles/index.scss';

initObservability();
initAnalytics();
initFeatureFlags();

// Initialize i18n before rendering
await initI18n();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <NiceModal.Provider>
      <Suspense fallback={<div>Loading translations...</div>}>
        <App />
      </Suspense>
    </NiceModal.Provider>
  </StrictMode>,
);
